import { Toaster as Sonner } from "sonner";
import "sonner/dist/styles.css";

export function Toaster() {
  return (
    <Sonner
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "w-[360px] min-h-[88px] bg-card border border-border text-card-foreground rounded-lg p-4",
        },
      }}
    />
  );
}
